import { sleep } from '@/utils/index';
import { SocketType, SocketCategory } from "@/common/constant/index";

// const WSS_SERVER = import.meta.env.WS;

type DataType = { type: SocketType, category: SocketCategory, data?: any };

export interface Socket {
    name: string;
    task: any;
    updateTime: number;
    reconnect: number;
    close: Function;
    send(info: { type: SocketType, category: SocketCategory, data?: any }): void;
    active: boolean;
    onOpen?: Function;
    onMessage?: Function;
    onClose?: Function;
    onError?: Function;
}

export enum SocketError {
    // 超过了最大重连次数
    MAX_RECONNECT_COUNT = "MAX_RECONNECT_COUNT_LIMIT",
    // token失效
    INVALID_TOKEN = "INVALID_TOKEN",
    MAX_COUNT = "MAX_COUNT_LIMIT",
    TIMEOUT = "TIMEOUT",
    OFFLINE = "OFFLINE"
};


class MSocket {

    static instance: MSocket;

    // 最多5个
    MAX_COUNT = 5;
    // 心跳间隔 5s
    HEART_INTERVAL = 5 * 1000;
    // 最大重连次数(避免无限次的刷爆服务器)
    MAX_RECONNECT_COUNT = 5;
    // 心跳的超时时间
    HEART_TIMEOUT = 0.5 * 1000;
    // 切后台判断时间阈值（ms）
    HIDE_TIME = 5 * 1000;

    // 当前链接数
    count = 0;

    // 内测心跳是否停止
    checkTimeoutId: number = -1;

    // 禁用
    forbidden = false;

    _map: Socket[] = [];

    // 用户切后台的时间
    _hideTimeStamp = -1;

    token = "";

    _heartTimer = 0;

    debug = false;

    // 时间胶囊
    timeCapsule: number[] = [];

    canUse() {
        const len = this.MAX_RECONNECT_COUNT * 2;
        const now = MSocket.now();
        if (this.timeCapsule.length < len) {
            this.timeCapsule.push(now);
            return true;
        } else {
            // 超过十个,则判断是否超过了是否可用
            const totalTime = 2 * 1000 * len;
            const diff = now - this.timeCapsule[0];
            if (diff < totalTime) {
                return false;
            } else {
                return true;
            }
        }
    }

    constructor() {
        if (MSocket.instance) {
            return MSocket.instance;
        } else {
            MSocket.instance = this;
        }
    }

    static now() {
        return Date.now();
    }

    static log(...params: any[]) {
        // this.debug&&console.log(...params);
    }

    // 网络正在连接
    isConnected = true;
    // 网络类型
    networkType = "";

    // 断网状态
    networkChange(isConnected: boolean, networkType: string) {
        if (isConnected) {
            if (!this.isConnected) {
                //网络重连了 
                this._check(true);
            } else if (this.networkType !== networkType) {
                // 切换网络了
                MSocket.log('切换网络了,', `${this.networkType}--->${networkType}`);
                this._check(true);
            }
        }
        this.networkType = networkType;
        this.isConnected = isConnected;
    }

    // 获取某个socket状态
    async getStatusByName(name: string): Promise<'online' | 'offline' | 'reconnect' | 'undefined'> {
        const taskIndex = this._getSocketIndexByName(name);
        if (taskIndex == -1) {
            return Promise.resolve('undefined');
        } else {
            if (this._map[taskIndex].reconnect == 0) {
                try {
                    await this._sendHeart(name);
                    return Promise.resolve('online');
                } catch (error) {
                    return Promise.resolve('offline');
                }
            } else if (this._map[taskIndex].reconnect >= this.MAX_RECONNECT_COUNT) {
                return Promise.resolve('offline');
            } else {
                // 正在重试
                return Promise.resolve('reconnect');
            }
        }
    }

    // 隐藏/展示改变
    visibleChange(bool: boolean) {
        if (!bool) {
            // 隐藏了，则尽量隐藏的时间
            this._hideTimeStamp = MSocket.now();
        } else {
            if (this.token && this._map?.length) {
                if (this._hideTimeStamp == -1) {
                    this._check(true);
                } else if (MSocket.now() - this._hideTimeStamp > this.HIDE_TIME) {
                    this.debug && console.log('超过了隐藏阈值，则判断链接是否失活/重连');
                    this._check(true);
                }
            }
        }
    }

    setToken(token: string) {
        this.token = token;
    }

    heartClose() {
        clearInterval(this.checkTimeoutId);
        this.checkTimeoutId = -1;
    }

    heartCheck() {
        if (this.checkTimeoutId !== -1) {
            // 已经在轮询了，
            return;
        }

        let latestTime = MSocket.now()

        // @ts-ignore
        this.checkTimeoutId = setInterval(() => {
            const now = MSocket.now();
            const diff = now - latestTime + 100;
            if (diff > this.HEART_INTERVAL) {
                latestTime = now;
                this._check();
            }
        }, this.HEART_INTERVAL);
    }

    sendLogin(name: string) {
        if (this.token) {
            this.send(name, { type: SocketType.LOGIN, category: SocketCategory.LOGIN, data: { token: this.token } });
        }
    }

    request(): any {
        const SocketTask = new WebSocket(import.meta.env.VITE_WS_PATH);

        return SocketTask;
    }

    private _initialTaskEvent(SocketTask: WebSocket, name: string) {

        SocketTask.addEventListener('open', (result: any) => {
            this.debug && console.log('onOpen' + name)
            this._update(name);
            this._onOpen(result, name);
        });

        SocketTask.addEventListener('close', async (result: any) => {
            this.debug && console.log("服务器关闭");
            this.debug && console.log('onClose,' + name);
            // this.debug&&console.log(result);

            // const index = this._getSocketIndexByName(name);
            // if (index !== -1) {
            //     this._map[index].active = false;
            //     this._check();
            // }
        })

        SocketTask.addEventListener('error', (result: any) => {
            this.debug && console.log('onError,' + name)
            // this._onError(result, name);
            this.debug && console.log(this._map);
        })

        SocketTask.addEventListener('message', (result: any) => {

            const data = typeof result.data == "string" ? JSON.parse(result.data) : result.data;
            if (data.category == "checkToken" && data.type == "fail") {
                console.log('无效的token');
                this.token = "";

                const index = this._getSocketIndexByName(name);
                if (index !== -1) {
                    this._map[index].onError?.(SocketError.INVALID_TOKEN);
                }
                return;
            }

            this.debug && console.log('onMessage' + name);
            this._update(name);
            this._onMessage(result, name);
        })
    }

    // 重连 
    reconnect(handle: Socket) {
        if (!handle.active && handle.reconnect >= this.MAX_RECONNECT_COUNT) {
            handle.reconnect = 0;
            this.reTry(handle);
        }
    }

    async reTry(handle: Socket) {
        if (!this.token) {
            return;
        }
        if (!handle) {
            return;
        }
        handle.reconnect += 1;

        if (handle.reconnect >= this.MAX_RECONNECT_COUNT) {
            MSocket.log("大于最大重连次数，放弃");
            handle.onError?.(SocketError.MAX_RECONNECT_COUNT);
            return;
        }

        // 关闭已存在的socket
        this._close(handle.task, "reconnect").catch(err => {
            this.debug && console.log(err);
        });

        // 创建socket
        const SocketTask = this.request();
        // 初始化监听事件
        this._initialTaskEvent(SocketTask, handle.name);

        handle.task = SocketTask;

        try {
            await sleep(1000);
            // 默认为激活了
            handle.active = true;
            // 检测是否活
            await this._sendHeart(handle.name);
            this.debug && console.log("ok");

        } catch (error) {
            this.debug && console.log('重连失败');
            // 重连失败 
            handle.active = false;
            MSocket.log("重连失败");
            await sleep(2 * 1000);

            if (!handle.active && handle.reconnect !== 0) {
                this.reTry(handle);
            }
        }
    }

    connect(name: string) {
        this.count += 1;
        this.debug && console.log('connect', this.count);
        if (this.count >= this.MAX_COUNT) {
            return null;
        }

        // 创建socket
        const SocketTask = this.request();
        // 初始化监听事件
        this._initialTaskEvent(SocketTask, name);

        const handle: Socket = {
            name,
            task: SocketTask,
            updateTime: MSocket.now(),
            reconnect: 0,
            active: false,
            // 不提供主动关闭的方法
            close: this._bindClose.call(this, name),
            send: this._bindSend.call(this, name)
        };

        this._map.push(handle);

        // 重新计算长度
        this.count = this._map.length;

        // 开启检测
        this.heartCheck();

        return handle;
    }

    getNameList(): string[] {
        return this._map.map(item => item.name);
    }

    close(name: string, reason: string) {
        return new Promise(async (resolve, reject) => {
            const index = this._getSocketIndexByName(name);
            if (index !== -1) {
                try {
                    await this._close(this._map[index].task, reason);
                    this._onClose(null, name);
                    resolve("success");
                } catch (error) {
                    reject(error);
                }
            }
        });
    }

    getSocketByName(name: string): Socket | null {
        const index = this._getSocketIndexByName(name);
        if (index !== -1) {
            // 异步触发onOpen方法
            setTimeout(() => {
                this._map[index].onOpen?.();
            }, 0);
            return this._map[index];
        } else {
            // 创建socket
            return this.connect(name);
        }
    }

    send(name: string, info: { type: SocketType, category: SocketCategory, data?: any }) {
        return new Promise(async (resolve, reject) => {
            if (!this.isConnected) {
                return reject(SocketError.OFFLINE);
            }
            const index = this._getSocketIndexByName(name);
            if (index !== -1) {
                try {
                    if (!this._map[index].active) {
                        return reject("not open");
                    }
                    const res = await this._send(this._map[index].task, this._createData(info));
                    resolve(res);
                } catch (error) {
                    this.debug && console.log(error);
                    if ((error as any).errMsg == "sendSocketMessage:fail Error: SocketTask.readyState is not OPEN") {
                        this._map[index].active = false;
                        reject(error);
                    } else {
                        reject(error);
                    }
                }
            }
        });
    }

    destroy() {
        this.forbidden = true;
        this._map.forEach(socket => {
            this._close(null, socket.name);
        })
        this._map.length = 0;
        this.heartClose();
    }

    private _createData(info: { type: SocketType, category: SocketCategory, data?: any }) {
        return {
            type: info.type,
            category: info.category,
            data: info.data || {},
        };
    }

    private _bindClose(name: string) {
        return (info: any) => {
            // 暂时什么都不做
            // this.close(name, info);
        }
    }

    private _bindSend(name: string) {
        return (info: DataType) => {
            this.send(name, info);
        }
    }

    private _sendClose(name: string) {
        this.send(name, { type: SocketType.CLOSE, category: SocketCategory.CLOSE });
    }

    // 检测更新
    private _check(force = false) {
        this.debug && console.log('check');
        if (this._map.length == 0) {
            console.log("没有可用的socket", this.token);
            if (this.token) {
                // 存在token,则开启一个
            } else {
                // 不存在token
            }
            return;
        }
        this._map.forEach((socket: Socket) => {
            const diff = MSocket.now() - socket.updateTime;
            if (!socket.active) {
                // 已经失活
                if (socket.reconnect == 0) {
                    this.reTry(socket);
                } else {
                    MSocket.log("正在重连");
                }
            } else if (diff > this.HEART_INTERVAL || force) {
                // 已经超时了或强制,判断是否失活
                this._sendHeart(socket.name).catch(err => {
                    if (socket.reconnect == 0) {
                        this.reTry(socket);
                    } else {
                        MSocket.log("正在重连");
                    }
                });
            } else {
                // 不超过，则发送正常的心跳
                this.send(socket.name, { type: SocketType.PING, category: SocketCategory.PING });
            }
        });
    }

    private _sendHeart(name: string) {
        clearTimeout(this._heartTimer);

        return new Promise((resolve, reject) => {
            const index = this._getSocketIndexByName(name);
            if (index !== -1) {

                const latestTime = this._map[index].updateTime;

                // @ts-ignore
                this._heartTimer = setTimeout(() => {
                    if (latestTime == this._map[index].updateTime) {
                        reject('timeout');
                    } else {
                        resolve(true);
                    }
                }, this.HEART_TIMEOUT);

                this.send(name, { type: SocketType.PING, category: SocketCategory.PING }).catch(err => {
                    clearTimeout(this._heartTimer);
                    reject(err);
                });
            } else {
                reject('undefined');
            }
        })
    }

    private _onMessage(res: { data: any }, name: string) {
        let _res = res.data;
        try {
            _res = typeof res.data == "string" ? JSON.parse(res.data) : _res;
        } catch (error) {
            _res = _res;
        }

        // if (_res.type == "ping") {
        //     return;
        // }
        const index = this._getSocketIndexByName(name);
        if (index !== -1) {
            this._map[index].onMessage?.(_res);
        }
    }

    private _onOpen(res: any, name: string) {
        const index = this._getSocketIndexByName(name);
        if (index !== -1) {
            this.send(name, { type: SocketType.PING, category: SocketCategory.PING });
            this.sendLogin(name);
            this._map[index].onOpen?.(res);
        }
    }

    private _update(name: string) {
        const index = this._getSocketIndexByName(name);
        if (index !== -1) {
            this._map[index].active = true;
            this._map[index].reconnect = 0;
            this._map[index].updateTime = MSocket.now();
        }
    }

    private _close(task: any, reason: string) {
        return new Promise((resolve, reject) => {
            if (!task || !task.close) {
                return reject("empty");
            }
            task.close({
                reason,
                success: (res: any) => {
                    resolve(res);
                },
                fail: (err: any) => {
                    reject(err);
                }
            });
        });
    }

    private _send(task: any, data?: any) {
        task.send(JSON.stringify(data))
        // return new Promise((resolve, reject) => {
        //     // task.send({
        //     //     data: JSON.stringify(data),
        //     //     success: (res: any) => {
        //     //         resolve(res);
        //     //     },
        //     //     fail: (err: any) => {
        //     //         reject(err);
        //     //     },
        //     // });
        // });
    }

    private _onClose(e: any, name: string) {
        const index = this._getSocketIndexByName(name);
        if (index !== -1) {
            // 1.发送close信息给服务器
            // this._sendClose(name);
            // 2.关闭websocket
            this._close(this._map[index].task, "close");
            const onClose = this._map[index].onClose;
            // 3.移除该实例
            this._map.splice(index, 1);
            this.count = this._map.length;
            // 如果没有了，则关闭检测
            if (this._map.length == 0) {
                this.heartClose();
            }
            // 4.触发onClose事件
            onClose?.(e);
        }
    }

    private _onError(e: any, name: string) {
        const index = this._getSocketIndexByName(name);
        if (index !== -1) {
            this._map[index].onError?.(e);
            // 发送心跳♥
            this._sendHeart(name);
        }
    }

    private _getSocketIndexByName(name: string): number {
        const index = this._map.findIndex(item => item.name == name);
        return index;
    }
}

export default MSocket;